module.exports = __webpack_public_path__ + "a90ef42bb79631aed3216dfc58f3c9a9.svg";